<div id="eq-search-modal" class="eq-fixed eq-h-full eq-w-full eq-inset-0 eq-overflow-auto eq-z-[1200] eq-hidden eq-bg-grey-dusty-10" >
  <div class="eq-flex eq-items-center eq-mb-4 eq-justify-end">
    <button type="button" aria-label="close-search" (click)="closeModal()" class="eq-flex eq-flex-row eq-items-center eq-pr-4 eq-pt-4 ">
      <i class="eq-icon-close eq-cursor-pointer  eq-text-i-32 xl:eq-text-i-48 eq-icon-color-default hover:eq-scale-110"></i>
    </button>
  </div>

  <form class="eq-container">
    <div class="eq-input-group eq-relative">
        <input
            type="search"
            [id]="'main_search'"
            [name]="'main_search'"
            class="eq-form-input eq-form--large !eq-pl-7"
            [placeholder]="rendering?.fields?.SearchInputPlaceholder?.value"
            [(ngModel)]="keyphrase"
            (input)="onKeyphraseClear($event)"
            (keydown.enter)="search()"
            (focus)="searchIsFocused = true" (blur)="searchIsFocused = false"
        />
        <a tabindex="-1" href="#search" (click)="$event.preventDefault(); search()" class="eq-absolute eq-left-[10px] eq-translate-y-[-50%] eq-top-[55%]">
          <i class="eq-icon eq-icon-search !eq-top-[20px] hover:eq-scale-110"></i>
        </a>

    </div>
  </form>
  <div class="eq-container">
    <div *ngIf="(searchResults.length == 0 && !noResultsFound) && (keyPhraseClear || isInitial)" id="search-swiper" class="swiper eq-swiper-slider eq-my-12 !eq-pb-9">
      <div class="eq-text-h-sm eq-font-bold eq-mb-6">{{rendering?.fields?.PopularLabel?.value}}</div>
     
        <div class="swiper-wrapper">
          <ng-container *ngFor="let result of searchResultsPopular; let i = index">      
              <div class="swiper-slide lg:eq-overflow-hidden !eq-h-auto">
                      <a class="eq-w-full sm:eq-min-h-[356px] sm:eq-max-w-[350px] eq-search-result-cards eq-p-5 eq-flex eq-flex-col eq-bg-white eq-cursor-pointer hover:eq-scale-110" href="{{result?.url}}">
                        <img *ngIf="result?.image_url && result?.image_url !== '[object Object]'" class="eq-h-14 eq-w-full eq-object-cover eq-mb-5" src="{{result?.image_url}}" alt="{{result?.heading1}}">
                        <h3 class="eq-font-bold eq-mb-1">{{result?.name}}</h3>
                        <p class="eq-text-sm eq-text-color-subtle eq-line-clamp-5">{{result?.description}}</p>
                      </a>
              </div> 
          </ng-container>
        </div>
      
      <div class="swiper-pagination eq-swiper-pagination-left eq-h-8"></div>
    </div>
  </div>


  <div *ngIf="searchResults.length > 0 && !keyPhraseClear" class="eq-my-9 eq-container">
    <div class="eq-text-h-sm eq-font-bold eq-mb-6">{{rendering?.fields?.LookingForLabel?.value}}</div>
    <div class="eq-grid eq-grid-cols-1 sm:eq-grid-cols-2 lg:eq-grid-cols-4 eq-gap-5 eq-justify-between eq-mt-9">
      <a *ngFor="let result of searchResults" class="eq-search-result-cards eq-p-5 eq-flex eq-flex-col eq-bg-white eq-cursor-pointer hover:eq-scale-110" href="{{result?.url}}" >
        <img *ngIf="result?.image_url && result?.image_url != '[object Object]'" class="eq-h-14 eq-w-full eq-object-cover eq-mb-5" src="{{result?.image_url}}" alt="{{result?.heading1}}">
        <h3 class="eq-font-bold eq-mb-1">{{result?.name}}</h3>
        <p class="eq-text-sm eq-text-color-subtle eq-line-clamp-5">{{result?.description}}</p>
        
      </a>
    </div>
    <button *ngIf="showMoreEnabled" type="button" (click)="search(8, searchResults.length)" class="eq-mx-auto eq-btn eq-btn-secondary eq-mt-6">{{rendering?.fields?.ShowMoreLabel?.value}}<i class="eq-icon eq-icon-arrow-down"></i></button>
  </div>

  <div *ngIf="noResultsFound" class="eq-my-9 eq-container">
    <h3 class="eq-text-h-sm-m lg:eq-text-h-sm eq-font-bold eq-text-color-brand eq-mb-5 eq-whitespace-pre-wrap eq-text-center">{{rendering?.fields?.NoResultsFoundText?.value}}</h3>
  </div>

  <div *ngIf="(searchResults.length == 0 && !noResultsFound) && (keyPhraseClear || isInitial)">
    <div class="eq-my-9 eq-container">
      <app-faqs [rendering]="rendering?.fields?.FAQList?.[0]"></app-faqs>
    </div>
  </div>

</div>

